import { render, staticRenderFns } from "./detaillabelInttranslation.vue?vue&type=template&id=5d10df72&scoped=true&"
import script from "./detaillabelInttranslation.vue?vue&type=script&lang=js&"
export * from "./detaillabelInttranslation.vue?vue&type=script&lang=js&"
import style0 from "./detaillabelInttranslation.vue?vue&type=style&index=0&id=5d10df72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10df72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VCol,VIcon,VRow})
